import Service from '@ember/service';
import ENV from '../config/environment';

export default class CookieService extends Service {
  setCookie(name, value, days = 30) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }

    const hostname = window.location.hostname;
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    const sameSite = '; SameSite=Lax';
    const path = '; path=/';

    let domain = '';

    if (ENV.environment === 'production') {
      if (hostname.endsWith('.nightwatch.io')) {
        domain = '; domain=.nightwatch.io';
      }
    } else if (hostname.endsWith('.netlify.app')) {
      domain = '; domain=.netlify.app';
    } else if (hostname.endsWith('.pages.dev')) {
      domain = '; domain=.pages.dev';
    }

    const cookieStr = `${name}=${value}${expires}${path}${sameSite}${secure}${domain}`;
    document.cookie = cookieStr;

    console.debug('[CookieService] Set cookie:', {
      name,
      value,
      hostname,
      environment: ENV.environment,
      cookieStr
    });
  }

  getCookie(name) {
    const nameEQ = `${name}=`;
    return document.cookie
      .split(';')
      .map(c => c.trim())
      .find(c => c.startsWith(nameEQ))
      ?.substring(nameEQ.length) || null;
  }

  deleteCookie(name) {
    const hostname = window.location.hostname;
    const expired = '; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    const path = '; path=/';
    const sameSite = '; SameSite=Lax';
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';

    let domains = ['']; // default, no domain
    if (ENV.environment === 'production' && hostname.endsWith('.nightwatch.io')) {
      domains.push('.nightwatch.io');
    } else if (hostname.endsWith('.netlify.app')) {
      domains.push('.netlify.app');
    } else if (hostname.endsWith('.pages.dev')) {
      domains.push('.pages.dev');
    }

    for (const domain of domains) {
      const domainPart = domain ? `; domain=${domain}` : '';
      document.cookie = `${name}=${expired}${path}${sameSite}${secure}${domainPart}`;
    }

    console.debug('[CookieService] Deleted cookie:', { name, domains });
  }
}
